import React from "react";
import { Modal } from "antd";
import UploadJson from "./Upload";

const UploadModal = ({
  isVisible,
  onClose,
  connectionId,
  fetchMappings,
  fetchData,
}) => {
  return (
    <Modal
      title="Create Mapping"
      open={isVisible}
      onCancel={onClose}
      footer={null}
    >
      <UploadJson
        connectionId={connectionId} // Your connection object
        fetchMappings={fetchMappings} // Function to refresh mappings
        fetchData={fetchData}
        onClose={onClose}
      />
    </Modal>
  );
};

export default UploadModal;
